goog.provide('el8.appchart.mainFeeds.chartFetch');

goog.require('el8.plrdata.base');
goog.require('el8.ptdata.fetch');
goog.require('el8.service.urls');
goog.require('el8.uiwidget.alert');


/**
 * This is a variant of el8.ptdata.fetch that is capable of dealing
 * with PLR data (i.e., results coming down belonging to other charts
 * linked to this patient)
 */
(function() {

    el8.appchart.mainFeeds.chartFetch = function(indexedItems, force, async, callbackFn) {

        if (!indexedItems) { return null; }

        var curPatientId = el8Globals.PATIENT_ID;

        var returnSingle = false;
        if (indexedItems instanceof Array) {
            if (!indexedItems.length) { return []; }
        } else {
            indexedItems = [indexedItems];
            returnSingle = true;
        }
        
        var results = []; // what we'll return
        var needFetch = []; // the subset we'll actually get from the server
        if (force) {
            // if force is true, we need to fetch every object
            needFetch = indexedItems;
            // results is an empty array of the correct length
            results = indexedItems.map(function() { return null; });
        } else {
            // Otherwise try to fetch locally first
            // (looking for PLR items, then regular pt data, then deleted pt data).
            // Only add items we can't find to needFetch
            indexedItems.map(function(item) {
                var r = el8.plrdata.getById(item.id, true);
                var entitySet;
                if (!r) {
                    entitySet = el8.ptdata.getEntitySet(el8.model.idToModelClass(item.id));
                    r = entitySet.getById(item.id, true);
                }
                if (!r) { r = entitySet.getDeletedById(item.id); }
                results.push(r);
                if (!r) {
                    var pseudoId = item.id;
                    if (item.authoring_practice_id &&
                        item.authoring_practice_id !== el8Globals.PRACTICE_ID) {
                            pseudoId = item.id + ':' + item.authoring_practice_id;
                    }
                    needFetch.push(pseudoId);
                }
            });
        }
        // At this point, 'results' should be the same length as
        // 'fetchIds' and contain only objects we want to return (null otherwise).
        // Meanwhile, 'needFetch' contains all the ids we need to fetch
        if (needFetch.length) {
            var url = el8.service.urls.get('fetchPatientItems', [curPatientId]);
            $.el8_ajax({
                type: 'GET',
                url: url,
                async: (async === true), // defaults to false, i.e. sync call
                data: { id: needFetch },
                success: function(data) {
                    // We assume the results come back in the same
                    // order as we sent up the ids
                    var fetched = data;
                    if (fetched.length !== needFetch.length) {
                        el8.uiwidget.alert('Sorry, there was an error fetching one of '+
                            'the documents you requested');
                    }
                    for(var i=0; i<results.length; i++) {
                        if (!results[i]) {
                            var obj = fetched.shift();
                            var entitySet;

                            // If this data belongs to another chart whose data we have access to
                            // don't cache it like it's data belonging to this chart
                            if (obj.patient_id && obj.patient_id !== curPatientId) {
                                entitySet = el8.plrdata.getModelClass(obj.id);
                            } else {
                                entitySet = el8.ptdata.getEntitySet(obj.model_class);
                            }
                            results[i] = entitySet.create(obj, true); // should NOT notify
                        }
                    }
                    if (callbackFn) { callbackFn(); }
                }
            });
        } else {
            if (callbackFn) { callbackFn(); }
        }
        return returnSingle ? results[0] : results;
    };

})();